<script>
export default {
  data() {
    return {
      stickyListener: null,
      isSticky: false,
      stickyThreshold: 0,
    }
  },
  methods: {
    onScroll() {
      this.isSticky = window.scrollY > this.stickyThreshold
    },
  },
  created() {
    if (!window) return
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
}
</script>
